import React from "react";
import { useTranslation } from "react-i18next";
import {
  hasMultipleLiveStations,
  stationLabel,
} from "../../utils/liveTrainingStations";
import {
  resolveExerciseStateIdFromRow,
  TE_STATE_FINALIZED,
  TE_STATE_PAUSED,
  TE_STATE_STARTED,
} from "../../utils/coachExerciseNavigation";

function stationStatus(station, realtimeByTeId = {}) {
  const list = station?.exercises || [];
  if (!list.length) return "empty";
  const states = list.map((ex) =>
    resolveExerciseStateIdFromRow(ex, realtimeByTeId)
  );
  if (states.some((s) => s === TE_STATE_STARTED || s === TE_STATE_PAUSED)) {
    return "live";
  }
  if (states.every((s) => s === TE_STATE_FINALIZED)) return "done";
  return "idle";
}

/**
 * Coach station switcher — tap a station to manage its tables, chrono, and timer.
 */
export function LiveTrainingStationTabs({
  stations = [],
  focusedTsgId = null,
  onSelectStation,
  realtimeByTeId = {},
}) {
  const { t } = useTranslation();
  if (!hasMultipleLiveStations(stations) || typeof onSelectStation !== "function") {
    return null;
  }

  return (
    <div
      className="lt-station-tabs"
      role="tablist"
      aria-label={t("liveTrainingStations") || t("planningStations") || "Stations"}
    >
      {stations.map((station) => {
        const id = String(station.tsg_id);
        const selected = String(focusedTsgId || "") === id;
        const status = stationStatus(station, realtimeByTeId);
        const label = stationLabel(station, t);
        const className = [
          "lt-station-tabs__btn",
          selected ? "lt-station-tabs__btn--selected" : "",
          status === "live" ? "lt-station-tabs__btn--live" : "",
          status === "done" ? "lt-station-tabs__btn--done" : "",
        ]
          .filter(Boolean)
          .join(" ");
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={selected}
            className={className}
            style={
              station.color
                ? { "--lt-station-accent": station.color }
                : undefined
            }
            onClick={() => onSelectStation(station.tsg_id)}
            title={label}
          >
            <span className="lt-station-tabs__dot" aria-hidden />
            <span className="lt-station-tabs__label">{label}</span>
            {status === "live" ? (
              <span className="lt-station-tabs__live">
                {t("liveTrainingStationLive") || "Live"}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default LiveTrainingStationTabs;
